// @flow
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import type { PaymentMethodsOrder } from '../../../types/payment-methods-order'
import PaymentMethod from '../../../types/payment-method'
import PaymentOption from '../../../types/payment-option'

export type PaymentState = {
  paymentMethodsOrder: ?PaymentMethodsOrder,
  selectedPaymentMethod: ?PaymentMethod,
  selectedPaymentOption: ?PaymentOption,
  storeUserPaymentConfirmed: boolean,
  previouslyLoggedIn: boolean
}
const state: PaymentState = {
  paymentMethodsOrder: null,
  selectedPaymentMethod: null,
  selectedPaymentOption: null,
  storeUserPaymentConfirmed: false,
  previouslyLoggedIn: false
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/payment/index.js